import script from "./SolutionView7.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionView7.vue?vue&type=script&setup=true&lang=js"

import "./SolutionView7.vue?vue&type=style&index=0&id=451a5b2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-451a5b2a"]])

export default __exports__